


















































































































































































































































import {TableHeaders} from '@/interfaces/components-data';
import {
    BootstrapSelectBox,
    CalcIndividualConfig,
} from '@/interfaces/global-data';
import {
  CalcIndividualConfigMap,
  EventsListItem,
  EventsListQuery,
  GetTaskInfo,
  LoadEventChangingType,
  LoadEventPeriods,
  LoadEventType,
  Page,
  TaskInfoFilterType,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import {AxiosResponse} from 'axios';
import moment from 'moment';
import Vue from 'vue';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';

class PaginationModel {
    [index: string]: any;
    constructor() {
        const self = this;
        return new Proxy(self, {
            get: (target: any, property: any, receiver: any) => {
                if (!(property in target)) {
                    Vue.set(target, property, null)
                }
                return target[property]
            },
            set: (target: any, property: any, value: any, receiver: any) => {
                Vue.set(target, property, value)
                return true;
            }});
    }
}

// tslint:disable-next-line: max-classes-per-file
@Component({
        components: {},
    })
export default class EventsList extends Mixins(LocalData, Toast, Http) {
        @Prop() readonly selectTradingId!: number | null;
        currentPage: number = 1;
        currentIndividualPage: number = 1;
        tableSize: number = 0;
        totalRows: number = 0;
        totalIndividualRows: number = 0;
        pageSize: number = 20;
        pageIndividualSize: number = 20;
        noNeedToLoad = false;
        filtersApplied = false;
        file: File | null = null;
        fileId: number = -1
        progressCounter: number = 0;
        loadProgress: boolean = false;
        proxyObj = new PaginationModel();

        defaultSelectBox: BootstrapSelectBox<number | null> = {
            value: null,
            text: this.$t('shared.selectBox.notSelected') as string,
        };

        storeRegions: Array<BootstrapSelectBox<number | null>> = [this.defaultSelectBox];
        storeFormats: Array<BootstrapSelectBox<number | null>> = [this.defaultSelectBox];
        storeClusters: Array<BootstrapSelectBox<number | null>> = [this.defaultSelectBox];
        groups: Array<BootstrapSelectBox<number | null>> = [this.defaultSelectBox];
        categories: Array<BootstrapSelectBox<number | null>> = [this.defaultSelectBox];
        subcategories: Array<BootstrapSelectBox<number | null>> = [this.defaultSelectBox];

        sortQuery: EventsListQuery = new EventsListQuery();

        individualParams: IndividualParamsMap = {};

        individualConfigFields: TableHeaders[] = [
            {
                key: 'internalCode',
                label: this.$t('shared.table.internalCode') as string,
            },
            {
                key: 'category.name',
                label: this.$t('shared.filters.productCategory') as string,
            },
            {
                key: 'group.name',
                label: this.$t('shared.filters.productGroup') as string,
            },
            {
                key: 'storeFormat.name',
                label: this.$t('shared.filters.storeFormatChannel') as string,
            },
            {
                key: 'storeRegion.name',
                label: this.$t('shared.filters.storeRegion') as string,
            },
            {
                key: 'subcategory.name',
                label: this.$t('shared.labels.productSubcategory') as string,
            },
            {
                key: 'storeCluster.name',
                label: this.$t('shared.filters.storeCluster') as string,
            },
            {
                key: 'delta',
                label: this.$t('events.table.deltaPercent') as string,
                formatter: (data: number) => data.toFixed(2),
            },
        ];

        newIndividualConfigFields: any[] = [
            {
                dataIndex: 'internalCode',
                title: this.$t('shared.table.internalCode') as string,
                ellipsis: true,
            },
            {
                dataIndex: 'category.name',
                title: this.$t('shared.filters.productCategory') as string,
                ellipsis: true,
            },
            {
                dataIndex: 'group.name',
                title: this.$t('shared.filters.productGroup') as string,
                ellipsis: true,
            },
            {
                dataIndex: 'storeFormat.name',
                title: this.$t('shared.filters.storeFormatChannel') as string,
                ellipsis: true,
            },
            {
                dataIndex: 'storeRegion.name',
                title: this.$t('shared.filters.storeRegion') as string,
                ellipsis: true,
            },
            {
                dataIndex: 'subcategory.name',
                title: this.$t('shared.labels.productSubcategory') as string,
                ellipsis: true,
            },
            {
                dataIndex: 'storeCluster.name',
                title: this.$t('shared.filters.storeCluster') as string,
                ellipsis: true,
            },
            {
                dataIndex: 'delta',
                title: this.$t('events.table.deltaPercent') as string,
                customRender: (data: number) => data.toFixed(2),
                ellipsis: true,
            },
        ];

        private fields: TableHeaders[] = [
            {
                key: 'edit',
                label: '',
                stickyColumn: true,
            },
            {
                key: 'event.storeFormat',
                label: this.$t('shared.filters.storeFormatChannel') as string,
                stickyColumn: true,
            },
            {
                key: 'event.storeRegions',
                label: this.$t('shared.filters.storeRegion') as string,
                stickyColumn: true,
            },
            {
                key: 'event.storeCluster',
                label: this.$t('shared.filters.storeCluster') as string,
                stickyColumn: true,
            },
            {
                key: 'event.groupsOfProduct',
                label: this.$t('shared.filters.productGroup') as string,
                stickyColumn: true,
            },
            {
                key: 'event.categories',
                label: this.$t('shared.filters.productCategory') as string,
                stickyColumn: true,
            },
            {
                key: 'event.subcategories',
                label: this.$t('shared.labels.productSubcategory') as string,
                stickyColumn: true,
            },
            {
                key: 'event.kviCartName',
                label: this.$t('shared.labels.kviCart') as string,
                stickyColumn: true,
            },
            {
                key: 'event.type',
                label: this.$t('shared.labels.type') as string,
                formatter: (data: LoadEventType) => this.$t(`events.types.${data}`) as string,
            },
            {
                key: 'event.changingType',
                label: this.$t('shared.labels.change') as string,
// tslint:disable-next-line: no-shadowed-variable
                formatter: (data: LoadEventChangingType) => this.$t(`events.changingTypes.${data}`) as string,
            },
            {
                key: 'event.periodicity',
                label: this.$t('shared.labels.periodicity') as string,
                formatter: (data: LoadEventPeriods) => this.$t(`events.periodicity.${data}`) as string,
            },
            {
                key: 'event.startDate',
                label: this.$t('shared.labels.startDate') as string,
                formatter: (data: any) => moment(new Date(data)).format('YYYY-MM-DD'),
            },
            {
                key: 'event.endDate',
                label: this.$t('shared.labels.endDate') as string,
                formatter: (data: any) => moment(new Date(data)).format('YYYY-MM-DD'),
            },
            {
                key: 'event.delta',
                label: this.$t('shared.labels.deviationPercent') as string,
            },
            {
                key: 'event.startCalculation',
                label: this.$t('shared.labels.recalculation') as string,
                formatter: (data: any, key: string, item: EventsListItem) => this.show(data, key, item, this.toYesOrNo),
            },
        ];

        private newFields: any[] = [
            {
                dataIndex: 'event.storeFormat',
                title: this.$t('shared.filters.storeFormatChannel') as string,
                scopedSlots: { filterDropdown: 'formatFilter', filterIcon: "formatFilterIcon" },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'event.storeRegions',
                title: this.$t('shared.filters.storeRegion') as string,
                scopedSlots: { filterDropdown: 'regionFilter', filterIcon: "regionFilterIcon" },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'event.storeCluster',
                title: this.$t('shared.filters.storeCluster') as string,
                scopedSlots: { filterDropdown: 'clusterFilter', filterIcon: "clusterFilterIcon" },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'event.groupsOfProduct',
                title: this.$t('shared.filters.productGroup') as string,
                scopedSlots: { filterDropdown: 'groupFilter', filterIcon: "groupFilterIcon" },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'event.categories',
                title: this.$t('shared.filters.productCategory') as string,
                scopedSlots: { filterDropdown: 'categoryFilter', filterIcon: "categoryFilterIcon" },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'event.subcategories',
                title: this.$t('shared.labels.productSubcategory') as string,
                scopedSlots: { filterDropdown: 'subcategoryFilter', filterIcon: "subcategoryFilterIcon" },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'event.kviCartName',
                title: this.$t('shared.labels.kviCart') as string,
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'event.type',
                title: this.$t('shared.labels.type') as string,
                customRender: (data: LoadEventType) => this.$t(`events.types.${data}`) as string,
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'event.changingType',
                title: this.$t('shared.labels.change') as string,
    // tslint:disable-next-line: no-shadowed-variable
                customRender: (data: LoadEventChangingType) => this.$t(`events.changingTypes.${data}`) as string,
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'event.periodicity',
                title: this.$t('shared.labels.periodicity') as string,
                customRender: (data: LoadEventPeriods) => this.$t(`events.periodicity.${data}`) as string,
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'event.startDate',
                title: this.$t('shared.labels.startDate') as string,
                customRender: (data: any) => moment(new Date(data)).format('YYYY-MM-DD'),
                width: 200,
            },
            {
                dataIndex: 'event.endDate',
                title: this.$t('shared.labels.endDate') as string,
                customRender: (data: any) => moment(new Date(data)).format('YYYY-MM-DD'),
                width: 200,
            },
            {
                dataIndex: 'event.delta',
                title: this.$t('shared.labels.deviationPercent') as string,
                width: 150,
                ellipsis: true,
            },
            {
                dataIndex: 'event.startCalculation',
                title: this.$t('shared.labels.recalculation') as string,
                customRender: (data: any, key: string, item: EventsListItem) => this.show(data, key, item, this.toYesOrNo),
                width: 150,
                ellipsis: true,
            },
        ];

        pagination: any = {
            pageSize: 20,
        }
        paginations: any = {}

        tableItems: any[] = [];

        private selectedStoreFormat: number | null = null;
        private selectedStoreRegion: number | null = null;

        private selectedStoreCluster: number | null = null;
        private selectedGroup: number | null = null;

        private selectedCategory: number | null = null;
        private selectedSubcategory: number | null = null;

    mounted() {
        if (this.selectTradingId !== -1 && this.selectTradingId !== null) {
            this.resetData(null);
        }
        EventBus.$on('onCalcParamsSaved', this.reset)

        this.noNeedToLoad = true;
        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({pagination: this.pagination}, () => {})
    }

    beforeDestroy() {
        EventBus.$off('onCalcParamsSaved', this.reset)
    }

    load() {
        if (!this.noNeedToLoad) {
            this.noNeedToLoad = true;
            (this.$refs.eventsListTable as any).refresh();
        }
    }

    reset() {
        this.noNeedToLoad = false;
    }

    onTableChange(pagination: any) {
        const pager = { ...pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetchList({pagination}, () => {})
    }

    onConfigTableChange(pagination: any, id: any) {
        const pager = { ...this.paginations[+id] };
        pager.current = pagination.current;
        this.paginations[+id] = pager;
        this.loadIndividualConfigs({
            apiUrl: +id,
            pagination
        }, () => {})
    }

    fetchList(ctx: any, callback: (items: EventsListItem[]) => void) {
        if (!this.noNeedToLoad || this.selectTradingId === null || this.selectTradingId === -1) {
            callback([]);
            return;
        }
        (this.$refs.statusModal as any).show();
        const query: EventsListQuery = new EventsListQuery();
        query.ascTn = this.sortQuery.ascTn;
        query.ascG = this.sortQuery.ascG;
        query.ascC = this.sortQuery.ascC;
        query.ascSubc = this.sortQuery.ascSubc;
        query.ascSC = this.sortQuery.ascSC;
        query.ascSR = this.sortQuery.ascSR;
        query.ascSF = this.sortQuery.ascSF;
        query.ascInternalCode = this.sortQuery.ascInternalCode;
        query.categories = this.sortQuery.categories;
        query.groupsOfProduct = this.sortQuery.groupsOfProduct;
        query.subcategories = this.sortQuery.subcategories;
        query.storeFormat = this.sortQuery.storeFormat;
        query.storeRegionValues = this.sortQuery.storeRegionValues;
        query.storeCluster = this.sortQuery.storeCluster;
        query.limit = ctx.pagination.pageSize;
        query.offset = (ctx.pagination.current - 1) * ctx.pagination.pageSize;
        this.httpFetchEventsTriggers(query)
                .then((res: AxiosResponse<Page<EventsListItem[]>>) => {
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.totalElements;
                    this.pagination = pagination;

                    this.totalRows = res.data.totalElements;
                    this.tableSize = res.data.content.length;

                    res.data.content.forEach((item) => {
                        this.paginations[+item.id] = {
                            pageSize: 10,
                            current: 1,
                        }
                    });

                    this.tableItems = res.data.content.map((item) => ({ ...item, individualConfigs: [] }));
                    callback(res.data.content);
                })
                .catch(() => {
                    callback([]);
                })
            .finally(() => {
                (this.$refs.statusModal as any).hide();
            });
    }

        resetByGroup() {
            this.resetData(TaskInfoFilterType.group);
        }

        resetByCategory() {
            this.resetData(TaskInfoFilterType.category);
        }

        resetBySubcategory() {
            this.resetData(TaskInfoFilterType.subcategory);
        }

        resetByStoreFormat() {
            this.resetData(TaskInfoFilterType.format);
        }

        resetByStoreRegion() {
            this.resetData(TaskInfoFilterType.region);
        }

        resetByStoreCluster() {
            this.resetData(TaskInfoFilterType.cluster);
        }

        applyFilters() {
            this.filtersApplied = true;
            const pager = { ...this.pagination };
            pager.current = 1;
            this.pagination = pager;
            this.fetchList({pagination: this.pagination}, () => {})
        }

        resetFilters() {
            this.resetData(null);
            if (this.filtersApplied) {
                this.filtersApplied = false;
                const pager = { ...this.pagination };
                pager.current = 1;
                this.pagination = pager;
                this.fetchList({pagination: this.pagination}, () => {})
            }
        }

    show(value: any, key: string, item: EventsListItem, formatter?: (data: any) => any): any | null {
        if (formatter != null) {
            return formatter(value)
        } else {
            return value
        }
    }

    toggleDescClass(field: TableHeaders) {
        if (!field.hasOwnProperty('thClass')) {
            field.thClass = ['desc'];
            return
        }
// tslint:disable-next-line: no-non-null-assertion
        const index: number = field.thClass!!.indexOf('desc')
        if (index !== -1) {
// tslint:disable-next-line: no-non-null-assertion
            field.thClass!!.splice(index, 1);
        } else {
// tslint:disable-next-line: no-non-null-assertion
            field.thClass!!.push('desc')
        }
    }

    onHeadClicked(key: string, field: TableHeaders, event: Event, isFooter: boolean) {
        const fieldDef = this.fields.find((value, index) => value.key === key);
        switch (key) {
            case 'storeFormat': {
                if (fieldDef != null) {
                    this.toggleDescClass(fieldDef)
                }
                this.sortQuery.ascSF = !this.sortQuery.ascSF;
                break;
            }
            case 'storeRegions' : {
                if (fieldDef != null) {
                    this.toggleDescClass(fieldDef)
                }
                this.sortQuery.ascSR = !this.sortQuery.ascSR;
                break;
            }
            case 'storeCluster' : {
                if (fieldDef != null) {
                    this.toggleDescClass(fieldDef)
                }
                this.sortQuery.ascSC = !this.sortQuery.ascSC;
                break;
            }
            case 'group' : {
                if (fieldDef != null) {
                    this.toggleDescClass(fieldDef)
                }
                this.sortQuery.ascG = !this.sortQuery.ascG;
                break;
            }
            case 'category' : {
                if (fieldDef != null) {
                    this.toggleDescClass(fieldDef)
                }
                this.sortQuery.ascC = !this.sortQuery.ascC;
                break;
            }
            case 'subcategories' : {
                if (fieldDef != null) {
                    this.toggleDescClass(fieldDef)
                }
                this.sortQuery.ascSubc = !this.sortQuery.ascSubc;
                break;
            }
            default: {
                event.preventDefault();
                return
            }
        }
        (this.$refs.eventsListTable as any).refresh();
    }

    openIndividualConfigs(row: any) {
        row.toggleDetails();
    }

    loadIndividualConfigs(ctx: any, callback: (items: any[]) => void) {
// tslint:disable-next-line: radix
        const id = parseInt(ctx.apiUrl);
        if (!this.noNeedToLoad || this.selectTradingId === null || this.selectTradingId === -1) {
            callback([]);
            return Promise.resolve();
        }
        (this.$refs.statusModal as any).show();
        const query: EventsListQuery = new EventsListQuery();
        query.ascTn = this.sortQuery.ascTn;
        query.ascG = this.sortQuery.ascG;
        query.ascC = this.sortQuery.ascC;
        query.ascSubc = this.sortQuery.ascSubc;
        query.ascSC = this.sortQuery.ascSC;
        query.ascSR = this.sortQuery.ascSR;
        query.ascSF = this.sortQuery.ascSF;
        query.ascInternalCode = this.sortQuery.ascInternalCode;
        query.categories = this.sortQuery.categories;
        query.groupsOfProduct = this.sortQuery.groupsOfProduct;
        query.subcategories = this.sortQuery.subcategories;
        query.storeFormat = this.sortQuery.storeFormat;
        query.storeRegionValues = this.sortQuery.storeRegionValues;
        query.storeCluster = this.sortQuery.storeCluster;
        query.limit = ctx.pagination.pageSize;
        query.offset = (ctx.pagination.current - 1) * ctx.pagination.pageSize;
        return this.httpFetchEventsProducts(id, query)
                .then((res) => {
                    (this.$refs.statusModal as any).hide();
                    this.$log.info(res.data)
                    this.paginations[+id].total = res.data.totalElements
                    const tableItems = [ ...this.tableItems ];
                    tableItems.find(i => i.id === id).individualConfigs = res.data.content;
                    this.tableItems = tableItems;
                    callback(res.data.content)
                })
                .catch(() => {
                    callback([]);
                });
    }

    private loadGroups() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
                .then((data) => {
                    const filterData = data.data;
                    this.groups = [this.defaultSelectBox, ...filterData.groups.map((i) => {
                        return {value: i.id, text: i.name}
                    })];
                })
                .catch((e) => {
                })
    }

    private loadCategories() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
                .then((data) => {
                    const filterData = data.data;
                    this.categories = [this.defaultSelectBox, ...filterData.categories.map((i) => {
                        return {value: i.id, text: i.name}
                    })];
                })
                .catch((e) => {
                })
    }

    private loadSubcategories() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                .then((data) => {
                    const filterData = data.data;
                    this.subcategories = [this.defaultSelectBox, ...filterData.subcategories.map((i) => {
                        return {value: i.id, text: i.name}
                    })];
                })
                .catch((e) => {
                })
    }

    private loadStoreFormats() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    this.storeFormats = [this.defaultSelectBox, ...filterData.storeFormat.map((i) => {
                        return {value: i.id, text: i.name}
                    })];
                })
                .catch((e) => {
                })
    }

    private loadStoreRegions() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    this.storeRegions = [this.defaultSelectBox, ...filterData.storeRegion.map((i) => {
                        return {value: i.id, text: i.name}
                    })];
                })
                .catch((e) => {
                })
    }

    private loadStoreClusters() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    this.storeClusters = [this.defaultSelectBox, ...filterData.storeCluster.map((i) => {
                        return {value: i.id, text: i.name}
                    })];
                })
                .catch((e) => {
                })
    }

    private getTaskInfo(type: TaskInfoFilterType): GetTaskInfo {
        return {
            type,
// tslint:disable-next-line: no-non-null-assertion
            tradingId: this.selectTradingId!!,
            categories: LocalData.filterNumberArrays([this.selectedCategory], true),
            groups: LocalData.filterNumberArrays([this.selectedGroup], true),
            subcategory: LocalData.filterNumberArrays([this.selectedSubcategory], true),
            segments: null,
            storeFormat: LocalData.filterNumberArrays([this.selectedStoreFormat], true),
            storeCluster: LocalData.filterNumberArrays([this.selectedStoreCluster], true),
            storeRegion: LocalData.filterNumberArrays([this.selectedStoreRegion], true),
            byReports: false,
            rulesListCondition: true,
        }
    }

    private resetData(type: TaskInfoFilterType | null = null) {
        switch (type) {
            case null:
                this.selectedGroup = null;
                this.selectedCategory = null;
                this.selectedSubcategory = null;
                this.selectedStoreFormat = null;
                this.selectedStoreRegion = null;
                this.selectedStoreCluster = null;
                this.groups = [this.defaultSelectBox];
                this.categories = [this.defaultSelectBox];
                this.subcategories = [this.defaultSelectBox];
                this.storeFormats = [this.defaultSelectBox];
                this.storeRegions = [this.defaultSelectBox];
                this.storeClusters = [this.defaultSelectBox];
                this.loadGroups();
                this.loadCategories();
                this.loadSubcategories();
                this.loadStoreFormats();
                this.loadStoreRegions();
                this.loadStoreClusters();
                break;
            case TaskInfoFilterType.group:
                this.selectedCategory = null;
                this.selectedSubcategory = null;
                this.selectedStoreFormat = null;
                this.selectedStoreRegion = null;
                this.selectedStoreCluster = null;
                this.categories = [this.defaultSelectBox];
                this.subcategories = [this.defaultSelectBox];
                this.storeFormats = [this.defaultSelectBox];
                this.storeRegions = [this.defaultSelectBox];
                this.storeClusters = [this.defaultSelectBox];
                this.loadCategories();
                this.loadSubcategories();
                this.loadStoreFormats();
                this.loadStoreRegions();
                this.loadStoreClusters();
                break;
            case TaskInfoFilterType.category:
                this.selectedSubcategory = null;
                this.selectedStoreFormat = null;
                this.selectedStoreRegion = null;
                this.selectedStoreCluster = null;
                this.subcategories = [this.defaultSelectBox];
                this.storeFormats = [this.defaultSelectBox];
                this.storeRegions = [this.defaultSelectBox];
                this.storeClusters = [this.defaultSelectBox];
                this.loadSubcategories();
                this.loadStoreFormats();
                this.loadStoreRegions();
                this.loadStoreClusters();
                break;
            case TaskInfoFilterType.subcategory:
                this.selectedStoreFormat = null;
                this.selectedStoreRegion = null;
                this.selectedStoreCluster = null;
                this.storeFormats = [this.defaultSelectBox];
                this.storeRegions = [this.defaultSelectBox];
                this.storeClusters = [this.defaultSelectBox];
                this.loadStoreFormats();
                this.loadStoreRegions();
                this.loadStoreClusters();
                break;
            case TaskInfoFilterType.format:
                this.selectedStoreRegion = null;
                this.selectedStoreCluster = null;
                this.storeRegions = [this.defaultSelectBox];
                this.storeClusters = [this.defaultSelectBox];
                this.loadStoreRegions();
                this.loadStoreClusters();
                break;
            case TaskInfoFilterType.region:
                this.selectedStoreCluster = null;
                this.storeClusters = [this.defaultSelectBox];
                this.loadStoreClusters();
                break;
        }
    }

    get emptyMessage(): string {
        if (this.filtersApplied) {
            return this.$t('events.messages.noSavedEventsForFilters') as string;
        } else {
            return this.$t('events.messages.noSavedEvents') as string;
        }
    }

        get isTradingSelected(): boolean {
            return this.selectTradingId === -1 || this.selectTradingId == null;
        }
}

interface IIndividualConfigsDAO {
   internalCode: string;
   config: CalcIndividualConfig
}

// tslint:disable-next-line: interface-name
interface IndividualConfigHolder {
    array: IIndividualConfigsDAO[];
    dictionary: CalcIndividualConfigMap;
}

// tslint:disable-next-line: interface-over-type-literal
type IndividualParamsMap = { [x: number]: IndividualConfigHolder }
